import { Link, useSearchParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const errorKey = params.get("error");
  const errorMsg =
    errorKey === "not_admin"
      ? "This account doesn't have admin access. Sign in with an authorised email."
      : errorKey === "auth_failed"
      ? "Authentication failed. Please try again."
      : "";

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-radial-fade pointer-events-none" />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#121212] p-8">
        <Link to="/" data-testid="admin-login-back-home" className="text-xs text-zinc-400 hover:text-white">
          ← Back to website
        </Link>
        <div className="mt-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#FE7200]/15 border border-[#FE7200]/40 text-[#FE7200]">
          <ShieldCheck className="h-6 w-6" />
        </div>
        <h1 className="mt-5 font-display text-3xl font-black tracking-tight">Admin Sign In</h1>
        <p className="mt-2 text-sm text-zinc-400">
          Sign in with your authorised Google account to manage blog posts and view submissions.
        </p>

        {errorMsg && (
          <div data-testid="admin-login-error" className="mt-5 rounded-md border border-red-500/40 bg-red-500/10 px-3 py-2 text-xs text-red-200">
            {errorMsg}
          </div>
        )}

        <button
          onClick={handleLogin}
          data-testid="admin-google-login-button"
          className="mt-6 inline-flex w-full items-center justify-center gap-3 rounded-full bg-white px-5 py-3 text-sm font-semibold text-black hover:bg-zinc-100 transition-colors"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.3 9.14 5.38 12 5.38z" />
          </svg>
          Sign in with Google
        </button>

        <p className="mt-6 text-xs text-zinc-500 text-center">
          Only admin emails configured by the site owner can access this area.
        </p>
      </div>
    </div>
  );
}
